import { ExternalLink, Link2, Trash2 } from "lucide-react";

import { Button } from "@/components/button";
import { convertUTCtoEastern } from "@/utils/timezoneConverter.ts";

import type { LinkAsset } from "../types.ts";

type UploadedLinkProps = {
  link: LinkAsset;
  onDelete: (attachmentId: number) => void;
};

export function UploadedLink({ link, onDelete }: UploadedLinkProps) {
  return (
    <div className="flex items-center justify-between gap-xs rounded-xl border border-border-secondary bg-bg-primary px-xl py-md">
      <div className="flex items-center gap-md overflow-hidden">
        <ExternalLink className="shrink-0 text-fg-quinary" size={16} />
        <div className="flex flex-col overflow-hidden">
          <a
            className="truncate text-sm font-medium text-utility-blue-700 hover:underline"
            href={link.url}
            rel="noreferrer"
            target="_blank"
            title={link.url}
          >
            {link.url}
          </a>
          {link.createdAt && (
            <span className="text-xs text-text-tertiary">
              Added {convertUTCtoEastern(link.createdAt, "MMM D, YYYY")}
            </span>
          )}
        </div>
      </div>
      <div className="flex gap-xs">
        <Button
          color="gray"
          isIconOnly
          onPress={() => onDelete(link.attachmentId)}
          size="sm"
          variant="tertiary"
        >
          <Trash2 className="text-button-tertiary-fg" />
        </Button>

        <Button asChild color="gray" isIconOnly size="sm" variant="tertiary">
          <a href={link.url} rel="noreferrer" target="_blank">
            <Link2 className="text-button-tertiary-color-fg" />
          </a>
        </Button>
      </div>
    </div>
  );
}
